// src/Dashboard/pages/user/Inscription/components/InscriptionHeader.jsx

import React from "react";
import {
  FaFolderOpen,
  FaPlus,
  FaSyncAlt,
  FaCheckCircle,
  FaFileAlt,
  FaEuroSign,
} from "react-icons/fa";

export default function InscriptionHeader({
  loading,
  onRefresh,
  onCreateAdherent,
}) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="bg-gradient-to-r from-[#013E8E] via-indigo-600 to-[#4CA82F] px-5 py-6 text-white sm:px-8">
        <div className="flex flex-col gap-5 xl:flex-row xl:items-center xl:justify-between">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-bold uppercase tracking-wide ring-1 ring-white/20">
              <FaFolderOpen />
              Dossier d’inscription
            </div>

            <h1 className="mt-4 text-2xl font-bold sm:text-3xl">
              Suivi des inscriptions et documents
            </h1>

            <p className="mt-2 max-w-4xl text-sm leading-6 text-white/90">
              Consultez l’état du dossier, ajoutez les documents demandés,
              vérifiez les validations du bureau et renouvelez facilement une
              adhésion pour la saison active.
            </p>

            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-2 rounded-2xl bg-white/15 px-3 py-2 text-xs font-bold ring-1 ring-white/20">
                <FaFileAlt />
                Documents
              </span>

              <span className="inline-flex items-center gap-2 rounded-2xl bg-white/15 px-3 py-2 text-xs font-bold ring-1 ring-white/20">
                <FaCheckCircle />
                Validation bureau
              </span>

              <span className="inline-flex items-center gap-2 rounded-2xl bg-white/15 px-3 py-2 text-xs font-bold ring-1 ring-white/20">
                <FaEuroSign />
                Règlement
              </span>
            </div>
          </div>

          <div className="flex flex-col gap-2 sm:flex-row xl:justify-end">
            <button
              type="button"
              onClick={onRefresh}
              disabled={loading}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white/15 px-4 py-3 text-sm font-bold text-white ring-1 ring-white/25 transition hover:bg-white/25 disabled:cursor-not-allowed disabled:opacity-70"
            >
              <FaSyncAlt className={loading ? "animate-spin" : ""} />
              Actualiser
            </button>

            <button
              type="button"
              onClick={onCreateAdherent}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white px-4 py-3 text-sm font-bold text-slate-900 shadow-sm transition hover:bg-white/90"
            >
              <FaPlus />
              Créer un nouvel adhérent
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}